export default __webpack_public_path__ + "assets/0d81066aacd927fdf6dbe42f8eb637b1.jpg";